import axios from 'axios';

// When REACT_APP_BACKEND_URL is empty or unset and REACT_APP_SAME_ORIGIN is true,
// API calls use relative URLs (e.g. /api/...) — the backend serves the SPA
// and API on the same origin (issue #65 unified Dockerfile).
// When REACT_APP_BACKEND_URL is set, calls go cross-origin (legacy S3+CloudFront mode).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

/**
 * Generic fetcher for React Query.
 * Handles the safe array extraction pattern used across the app.
 */
export async function apiFetch(url, headers) {
    const res = await axios.get(`${API}${url}`, { headers });
    return res.data;
}

/**
 * Safely extract an array from an API response that may be
 * either an array or a paginated object { data: [], total, page, page_size }.
 */
export function extractArray(data) {
    if (Array.isArray(data)) return data;
    return data?.data || [];
}

/**
 * Combined: fetch + extract array in one call.
 */
export async function apiFetchArray(url, headers) {
    const data = await apiFetch(url, headers);
    return extractArray(data);
}

/**
 * POST/PUT/DELETE helper for mutations.
 */
export async function apiPost(url, body, headers) {
    const res = await axios.post(`${API}${url}`, body, { headers });
    return res.data;
}

export async function apiPostForm(url, formData, headers) {
    const res = await axios.post(`${API}${url}`, formData, { headers });
    return res.data;
}

export async function apiPut(url, body, headers) {
    const res = await axios.put(`${API}${url}`, body, { headers });
    return res.data;
}

export async function apiPatch(url, body, headers) {
    const res = await axios.patch(`${API}${url}`, body, { headers });
    return res.data;
}

export async function apiDelete(url, headers) {
    const res = await axios.delete(`${API}${url}`, { headers });
    return res.data;
}

export { API };
